// SearchModal.jsx
import React, { useEffect, useRef, useState } from "react";

export function SearchModal({ open, onClose, onSearch ,search}) {
  const [mounted, setMounted] = useState(open);
  const [active, setActive] = useState(false);
  const inputRef = useRef(null);
    const [inputValue, setInputValue] = useState(search || "");

  useEffect(() => {
    if (open) {
      setMounted(true);
      setTimeout(() => {
        setActive(true);
        // focus after animation start
        setTimeout(() => inputRef.current?.focus(), 120);
      }, 10);
    } else {
      setActive(false);
      setTimeout(() => setMounted(false), 300);
    }
  }, [open]);

  if (!mounted) return null;

  // const submit = () => {
  //   const q = inputRef.current?.value ?? "";
  //   if (q.trim()) {
  //     onSearch?.(q.trim());
  //     // close after search
  //     setTimeout(() => onClose?.(), 150);
  //   }
  // };
    const submit = () => {
        const q = inputValue.trim();

        if (q) {
            onSearch?.(q);
            onClose?.();
        }
    };

  return (
    <div className="fixed inset-0 z-20 w-full h-max pt-[100px]  px-[20px]">
    
      <div
        className={` inset-0 flex flex-col rounded-lg bg-white transform transition-transform duration-300 ${active ? "max-h-[400px] opacity-100 " : "max-h-0 opacity-0"}`}
        role="dialog"
        aria-modal="true"
      >
          <div className="px-7 pt-3">

                <div className="flex items-start justify-between">
                <button onClick={() => onClose?.()} className="text-gray-500 hover:text-gray-700">
                    ✕
                </button>
                <h3 className="text-lg font-bold px-2">News Filter</h3>

                </div>
        </div>

        <div className="p-6 space-y-4 h-max">
          <div className="relative">
            <input
              ref={inputRef}
              value={inputValue}
              onChange={(e)=>{setInputValue(e.target.value)}}
              placeholder="Search..."
              className="w-full pl-12 pr-4 py-3 h-[40px] bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            //   onKeyDown={(e) => {
            //     if (e.key === "Enter") submit();
            //   }}
            />
            <i className="fas fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
          </div>

          <div className="space-y-2 h-[60px] flex flex-col items-end">
            <h4 className="text-sm font-medium text-gray-700 text-right">Recent Searches</h4>
            <div className="flex flex-row gap-2 max-h-[30px] justify-start">
              <button onClick={() => { inputRef.current.value = "بیت کوین"; submit(); }} className="w-max h-full text-center p-3 bg-gray-50 text-gray-700 rounded-xl  transition-colors text-xs flex flex-col justify-center items-center">بیت کوین</button>
              <button onClick={() => { inputRef.current.value = "بورس تهران"; submit(); }} className="w-max h-full text-center p-3 bg-gray-50 rounded-xl  text-gray-700 transition-colors text-xs flex flex-col justify-center items-center">بورس تهران</button>
              <button onClick={() => { inputRef.current.value = "قیمت طلا"; submit(); }} className="w-max h-full text-center p-3 bg-gray-50 rounded-xl  text-gray-700  transition-colors text-xs flex flex-col justify-center items-center">قیمت طلا</button>
            </div>
          </div>

          <button onClick={submit} className="w-full h-[40px] mt-2 flex flex-col justify-center items-center bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-medium transition-colors">Search</button>
        </div>
      </div>
    </div>
  );
}
